module.exports = __webpack_public_path__ + "img/127.202abd00.jpg";